export enum DataChangeDomain {
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  DEVICE = 'DEVICE',
  PATIENT = 'PATIENT',
  UNKNOWN = 'UNKNOWN',
}
